// extracted by mini-css-extract-plugin
module.exports = {"page":"e_1z","overview":"e_2z","anchor":"e_3z","breadcrumbs":"e_4z","dealCta":"e_5z","ethics":"e_6z"};